// Attention list — chronological problem periods (not days). Tap
// jumps to the day's detail popover.
export function AttentionList({ days, onSelect, tierColors }) {
  const rows = [];
  const tierRank = { red: 3, orange: 2, yellow: 1, green: 0, gray: -1 };
  for (const d of days) {
    if (d.closed) continue;
    for (const p of (d.periods || [])) {
      const req = Number(p.required_staff) || 0;
      const avail = Number(p.min_available) || 0;
      if (avail >= req || req === 0) continue;
      const ratio = req > 0 ? avail / req : 1;
      const periodTier = ratio >= 0.75 ? 'yellow' : ratio >= 0.5 ? 'orange' : 'red';
      rows.push({ day: d, period: p, tier: periodTier });
    }
  }
  rows.sort((a, b) => {
    const r = tierRank[b.tier] - tierRank[a.tier];
    if (r !== 0) return r;
    return a.day.ymd.localeCompare(b.day.ymd);
  });
  if (rows.length === 0) {
    return (
      <div style={{ padding: 16, textAlign: 'center', color: '#4caf50', fontSize: 13 }}>
        ✓ No coverage issues in the outlook window.
      </div>
    );
  }
  function fmt(t) {
    if (!t || typeof t !== 'string') return '';
    const [h, m] = t.split(':').map((x) => parseInt(x, 10));
    const hr = h === 0 ? 12 : h > 12 ? h - 12 : h;
    const ap = h < 12 ? 'a' : 'p';
    return m === 0 ? `${hr}${ap}` : `${hr}:${String(m).padStart(2,'0')}${ap}`;
  }
  const reasonShort = {
    approved_tor: 'TOR',
    pending_tor: 'TOR·pending',
    availability_reduction: 'unavail',
    other_location: 'other café',
  };
  return (
    <div>
      {rows.slice(0, 20).map(({ day, period, tier }, i) => {
        const c = tierColors[tier] || tierColors.gray;
        const off = (period.staff_off || []).slice(0, 3).map((s) => {
          const label = (s.reasons || []).map((r) => reasonShort[r] || r).join('/');
          return `${s.name}${label ? ` (${label})` : ''}`;
        }).join(', ');
        const extra = (period.staff_off || []).length - 3;
        const dayLabel = new Date(day.ymd + 'T12:00:00Z').toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
        return (
          <button key={i}
            onClick={() => onSelect(day)}
            style={{
              display: 'grid', gridTemplateColumns: '76px 128px 80px 1fr',
              gap: 10, alignItems: 'center', width: '100%',
              padding: '8px 10px', border: 'none', borderBottom: '1px solid #f0f0f0',
              background: 'transparent', textAlign: 'left', cursor: 'pointer',
              fontFamily: 'inherit', color: '#212121',
            }}>
            <span style={{
              fontSize: 10, fontWeight: 800, textTransform: 'uppercase', letterSpacing: 0.5,
              padding: '2px 8px', borderRadius: 999,
              background: c.stripe, color: '#fff', justifySelf: 'start',
            }}>{tier}</span>
            <span style={{ fontSize: 12, fontWeight: 700 }}>{dayLabel}</span>
            <span style={{ fontSize: 12, color: '#37474f' }}>{period.name} · {fmt(period.start_time)}–{fmt(period.end_time)}</span>
            <span style={{ fontSize: 12, color: '#37474f' }}>
              <b>{period.min_available}/{period.required_staff}</b>
              {off && <span style={{ color: '#757575' }}> · off: {off}{extra > 0 ? ` +${extra}` : ''}</span>}
            </span>
          </button>
        );
      })}
      {rows.length > 20 && (
        <div style={{ padding: 8, fontSize: 11, color: '#9e9e9e', fontStyle: 'italic' }}>
          … {rows.length - 20} more
        </div>
      )}
    </div>
  );
}
